import { HeadCell } from './LaborCost.types'

export const laborCostTableHeaders: HeadCell[] = [
  {
    id: 'procedureType',
    label: 'PROCEDURE TYPE',
    numeric: true,
    sx: {
      minWidth: '200px',
      width: 'auto',
    },
  },
  {
    id: 'rnCost',
    label: 'RN COST/HOUR',
    numeric: true,
    sx: {
      minWidth: '120px',
      width: 'auto',
    },
  },
  {
    id: 'scrubTechCost',
    label: 'SCRUB TECH COST/HOUR',
    numeric: true,
    sx: {
      minWidth: '180px',
      width: 'auto',
    },
  },
  {
    id: 'updatedAt',
    label: 'UPDATED AT',
    numeric: true,
    sx: {
      minWidth: '140px',
      width: 'auto',
    },
  },
  {
    id: 'actions',
    label: 'ACTIONS',
    numeric: true,
    sx: {
      minWidth: '120px',
      width: 'auto',
    },
  },
]

export const uploadedLaborCostTableHeaders: HeadCell[] = [
  {
    id: 'procedureType',
    label: 'Procedure Type',
    numeric: true,
  },
  {
    id: 'rnCost',
    label: 'RN Cost/hour',
    numeric: true,
  },
  {
    id: 'scrubTechCost',
    label: 'Scrub Tech Cost/hour',
    numeric: true,
  },
]
